import { api_configuration } from "../../common";
import api_cs = api_configuration.types.client_state.alan_api;
import { ObservableSet } from "../observableTypes";
import * as ResolveStatus from "../state/ResolveStatus";

export const resolvingReferences = new ObservableSet<api_cs.Cresolve_status>();
export async function referencesResolved(): Promise<void> {
	return resolvingReferences.size.await((value) => value <= 0);
}

export function subscribeToReference(reference: api_cs.Cresolve_status): void {
	const subscription = reference.properties.status.subscribe({
		on_update: () => {
			if (ResolveStatus.isBusyResolving(reference)) {
				resolvingReferences.add(reference);
			} else {
				resolvingReferences.delete(reference);
			}
		},
	});
	reference.onDestroy(() => {
		resolvingReferences.delete(reference);
		subscription.unsubscribe();
	});
}
